export function sortFieldsByOrder(providedFields: FieldDto[], object?: ObjectDto): FieldDto[] {
    const fieldsOrder = object?.options?.fields_order?.reduce(
        (acc, apiName, idx) => acc.set(apiName, idx),
        new Map<string, number>()
    )

    return providedFields.sort((a, b) => {
        // Primary fields should always be first.
        if (a.is_primary) return -1
        if (b.is_primary) return 1

        // If the object has a custom fields order, sort by that.
        if (fieldsOrder) {
            const aOrder = fieldsOrder.get(a.api_name) || Number.MAX_VALUE
            const bOrder = fieldsOrder.get(b.api_name) || Number.MAX_VALUE

            return aOrder - bOrder
        }

        // Otherwise, sort by created date.
        const aCreatedDate = a.created_date || ''
        const bCreatedDate = b.created_date || ''

        return aCreatedDate.localeCompare(bCreatedDate)
    })
}
